import text from './resources/locale/en.json';

class QuestionsPhonePreview {
    $onInit() {
        this.text = text;
    }
}

export default QuestionsPhonePreview;
